import React from "react";

import Box from "../Box";

const One = props => {
  return (
    <section className="hp__block hp__block hp__block--one container">
      <div className="row hp__block__row hp__block__row--first">
        <Box
          {...props}
          id="b1"
          type="news"
          settings={props.settings.b1}
          classes="col-xs-12"
          thumbnailWidth="1142"
        />
      </div>
    </section>
  );
};

export default One;
